import React from 'react';
import { NetlifyLogsButton } from '~/components/ui/NetlifyLogsButton';
import { InspectDeploymentButton } from './InspectDeploymentButton';
import type { ErrorDisplayProps } from '~/lib/types/netlify';

export const ErrorDisplay = ({
  error,
  adminUrl,
  onFixWithDualite,
  deployedId,
  accessToken,
  deployStatus,
}: ErrorDisplayProps) => {
  return (
    <div className="space-y-4">
      <div className="rounded-lg border border-[#ef4444]/20 bg-[#ef4444]/10 p-4">
        <div className="flex items-start gap-3">
          <div className="i-ph:warning-circle w-5 h-5 text-[#ef4444] flex-shrink-0 mt-0.5" />
          <div className="flex-1">
            <p className="text-[#ef4444] text-sm font-medium mb-1">Deployment Failed</p>
            <p className="text-[#ef4444]/90 text-sm">
              {error?.includes('rate limit') ? (
                <>
                  Rate limit reached. Please wait 5 minutes before trying again.
                  <br />
                  <span className="text-xs opacity-80 mt-1 block">
                    This helps ensure fair usage of Netlify's services.
                  </span>
                </>
              ) : (
                error
              )}
            </p>
          </div>
        </div>
      </div>

      {/* Use the consistent InspectDeploymentButton component */}
      {adminUrl && <InspectDeploymentButton adminUrl={adminUrl} />}

      {/* Add NetlifyLogsButton for error state */}
      {deployedId && (
        <div className="mt-2">
          <NetlifyLogsButton
            deployedId={deployedId}
            accessToken={accessToken}
            deployStatus={deployStatus}
            autoExpand={deployStatus === 'error'}
            adminUrl={adminUrl}
          />
        </div>
      )}
      {/* Fix with Dualite button */}
      <button
        id="fix-with-dualite-button"
        onClick={onFixWithDualite}
        className="w-full px-4 py-2.5 bg-gradient-to-b from-alpha-primary-start to-alpha-primary-end 
          rounded-lg text-white text-sm font-medium hover:brightness-110 transition-all
          flex items-center justify-center gap-2"
      >
        <div className="i-ph:wrench w-4 h-4" />
        <span>Fix with Dualite</span>
      </button>
    </div>
  );
};
